<template>
  <v-container style="width: 100%; padding-bottom: 200px;">
    <v-layout justify-space-between>
      <h1>Driver Groups</h1>
      <v-btn href="/settings/driver_group/create" color="green" dark class="text-none">Add New Driver Group</v-btn>
    </v-layout>
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8 py-3>
          <DriverGroupList :driverGroups="driverGroups" @orderChange="changeOrder($event)"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import DriverGroupList from "@/components/settings/general/driver/DriverGroupList.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "operating_regions",
  components: {
    DriverGroupList
  },
  data: function() {
    return {
      driverGroups: null
    };
  },
  mounted: function() {
    setTimeout(this.getDriverGroups, 300);
  },
  methods: {
    getDriverGroups: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/driver_group/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.driverGroups = response.data;
      } catch {
        print(e,x);
      }
      
    }
  }
};
</script>
